<template>
	<div class="tabTrailerTypes">
		<div class="fieldGroup">
			<div class="groupFieldTitle">
				<span>Trailer types</span>
				<button type="button" @click="onAddItem">
					<svg-sprite width="20" height="20" icon-id="addItem"></svg-sprite>
				</button>
			</div>
			<template v-for="({ name, trailer_type_id, status }, idx) in trailerType">

				<div class="groupField_wrap" :key="idx" v-if="status">
					<field
							:classError="getError(idx)"
							margin="0 0 10px 0"
							width="346px"
							label="Type"
							placeholder="Enter type"
							@updateInput="onInput($event, trailer_type_id)"
							:setInputValue="name"
							:idx="idx"
							is-required
							is-trim
					></field>
					<button
							type="button"
							class="deleteItem"
							@click="onDeleteItem(idx)"
					>
						<svg-sprite
								width="20"
								height="20"
								icon-id="deleteItem"
						></svg-sprite>
					</button>
				</div>
			</template>
		</div>
	</div>
</template>

<script>
export default {
	name: "TrailerTypes",
	props: {
		valid: Object,
		trailerType: Array,
		tabPermissionId: Number,
	},
	methods: {
		getError(idx) {
			return this.valid.trailer_type?.$each?.$iter[idx]?.name?.$error;
		},
		onInput(value) {
			this.$emit("updateDepartmentsListEdit", value);
		},
		onAddItem() {
			const item = { status: 1, trailer_type_id: null, name: null };
			this.$emit("updateDepartmentsList", { item });
		},
		onDeleteItem(idx) {
			this.$emit("updateDepartmentsListDelete", idx);
		},
	},
};
</script>
<style scoped lang="scss">
.warning_block {
	font-weight: 500;
	font-size: 14px;
	line-height: 20px;
	letter-spacing: 0.25px;
	color: #f49741;
	display: flex;
	align-items: center;
	margin-bottom: 10px;

	span {
		margin-left: 10px;
		display: inline-block;
	}
}

.switch {
	margin-bottom: 20px;
}

.deleteItem {
	margin-left: 20px;
	color: #19bc38;

	&[disabled] {
		cursor: default;
		color: rgba(255, 255, 255, 0.6);
	}
}

.groupField {
	background: #1c1c28;
	width: 100%;
	max-width: 560px;

	&Title {
		margin-bottom: 10px;
		font-weight: 500;
		font-size: 14px;
		line-height: 20px;
		letter-spacing: 0.25px;
		color: #8f90a6;
		width: 100%;
		display: flex;
		justify-content: space-between;
		min-width: 380px;

		button {
			height: 20px;
			color: #19bc38;

			&[disabled] {
				cursor: default;
				color: rgba(255, 255, 255, 0.6);
			}
		}
	}

	&_wrap {
		display: flex;
		align-items: center;
		justify-content: space-between;
	}
}
</style>
